import React, { useEffect } from "react";
import Loader from "../../SharedComponents/Loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { Col, Modal, Row } from "antd";
import Commonselectfield from "../../Components/CommonForms/CommonSelectField";
import { useFormik } from "formik";
import * as Yup from "yup";
import classes from "../Modal.module.css";
import CommonButton from "../../Components/Buttons/CommonButton";
import { AccessTypeOptions } from "../../Shared/Constants";
import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";
import {
  CreateUserDeviceMapping,
  UpdateUserDeviceMapping,
} from "../../Services/ApiServices";
import { CatchMessage, JSONtoformdata } from "../../Shared/Methods";
import { toast } from "react-toastify";

interface props {
  handleSuccess: () => void;
  onCancel: () => void;
  item: any;
  closable: boolean;
  open: boolean;
  DropDowns: any;
  DropdownMethods: any;
  action: string;
}

interface formikprops {
  deviceId: any[];
  user_id: string;
  access_type: any;
  mapping_id: any;
}

const validation = Yup.object().shape({
  deviceId: Yup.array()
    .min(1, "Must have at least one Device")
    .required("Device is Required"),
  access_type: Yup.string().required("Access Type is required"),
});

function AddUserdevicemodal({
  handleSuccess,
  onCancel,
  item,
  closable,
  open,
  DropDowns,
  DropdownMethods,
  action,
}: props) {
  const { getDeviceDropDown } = DropdownMethods;
  const { Device, isDeviceLoading } = DropDowns;
  // const dublicate = [...Device, { deviceName: "demo", deviceId: 2 }];
  const { LoginData } = useSelector((state: any) => state.Auth);
  const { loading } = useSelector((state: any) => state.Dashboard);
  const dispatch = useDispatch();

  const {
    values,
    errors,
    touched,
    setFieldValue,
    handleChange,
    setValues,
    handleSubmit,
  } = useFormik({
    initialValues: {
      deviceId: [""],
      user_id: "",
      access_type: null,
      mapping_id: "",
    },
    validationSchema: validation,
    onSubmit: (Values: formikprops) => {
      if (action === "Assign") {
        handleCreateDeviceMapping();
      } else handleUpdateDeviceMapping();
    },
  });

  useEffect(() => {
    if (action === "Assign") {
      setFieldValue("user_id", item?.id);
      setFieldValue("deviceId", action === "Assign" && []);
    } else if (action === "Update") {
      setValues({
        access_type: item?.access_type || null,
        deviceId: [item?.device_code] || [],
        user_id: item?.user_id || "",
        mapping_id: item?.id || "",
      });
    }
    getDeviceDropDown();
  }, []);

  const handleCreateDeviceMapping = () => {
    dispatch(handleloading(true));
    let finalObj = {
      token: LoginData?.token,
      ...values,
    };

    CreateUserDeviceMapping(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res?.data?.status == 1) {
          handleSuccess();
          toast.success(res?.data?.msg);
          onCancel();
        }
        if (res?.data?.status == 0) {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const handleUpdateDeviceMapping = () => {
    dispatch(handleloading(true));
    let finalObj = {
      token: LoginData?.token,
      ...values,
      deviceId: item?.device_id,
    };

    UpdateUserDeviceMapping(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res?.data?.status == 1) {
          handleSuccess();
          toast.success(res?.data?.msg);
          onCancel();
        }
        if (res?.data?.status == 0) {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  return (
    <>
      <Loader isLoader={loading} />
      <Modal open={open} closable={closable} width={400} footer={null}>
        <div className={classes.modal_container}>
          <h4 className={classes.modal_heading}>{action} Device</h4>

          <Row gutter={[16, 16]}>
            <Col xl={24} lg={12} md={24} sm={12} xs={24}>
              <Commonselectfield
                labelname="Device"
                value={values.deviceId}
                onChange={(value) => {
                  setFieldValue("deviceId", value);
                }}
                style={{ width: "100%" }}
                options={Device?.map((ele: any) => {
                  return { label: ele?.deviceName, value: ele?.deviceId };
                })}
                size="large"
                required={true}
                error={errors}
                touched={touched}
                mode="multiple"
                name="deviceId"
                disabled={isDeviceLoading}
                loading={isDeviceLoading}
              />
            </Col>
            <Col xl={24} lg={12} md={24} sm={12} xs={24}>
              <Commonselectfield
                labelname="Access Type"
                value={values.access_type}
                onChange={(value) => {
                  setFieldValue("access_type", value);
                }}
                style={{ width: "100%" }}
                options={AccessTypeOptions}
                size="large"
                required={true}
                error={errors}
                touched={touched}
                name="access_type"
              />
            </Col>
          </Row>

          <div className={classes.modal_button_container}>
            <CommonButton
              name="Submit"
              onClick={handleSubmit}
              type="submit"
              classname="submit_btn"
            />
            <CommonButton
              name="Cancel"
              type="button"
              onClick={() => onCancel()}
              style={{ backgroundColor: "#eb3131" }}
              classname="cancel_btn"
            />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default AddUserdevicemodal;
